import { render, staticRenderFns } from "./vistaContratoRectificaciones.vue?vue&type=template&id=21c4f6f0&scoped=true"
import script from "./vistaContratoRectificaciones.vue?vue&type=script&lang=js"
export * from "./vistaContratoRectificaciones.vue?vue&type=script&lang=js"
import style0 from "./vistaContratoRectificaciones.vue?vue&type=style&index=0&id=21c4f6f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4f6f0",
  null
  
)

export default component.exports